<div class="processing">
  <div class="img-container">
    <img src="/assets/playlist-processing.svg" alt="" />
    <img src="/assets/loader-playlist.svg" alt="" />
  </div>
  <div>
    {{ text }}
  </div>
</div>
